<template>
	<el-row>
		<el-form ref="info" :model="info" :rules="infoRuels" label-position="right" label-width="100px">
			<el-form-item label="作业标题:" prop="name">
				<el-input size="mini" placeholder="200字内" maxlength="200" v-model="info.name" style="width: 800px;">
				</el-input>
			</el-form-item>
			<el-form-item label="交作业形式:" prop="status">
				<el-radio-group v-model="info.status">
					<el-radio :label="1">文本+图片+视频均可</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="状态:" prop="value1">
				<el-switch v-model="info.value1" active-text="开" inactive-text="关">
				</el-switch>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="medium" @click="chuangjian">确认创建</el-button>
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				info: {
					name: "",
					status: 1,
					value1: '开'
				},
				infoRuels: {
					name: [{
						required: true,
						message: '请输入作业标题',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择交作业形式',
						trigger: 'blur'
					}],
					value1: [{
						required: true,
						message: '请选择状态',
						trigger: 'blur'
					}]
				},
			}
		},
		methods: {
			chuangjian() {
				this.$refs['info'].validate(valid => {
					if (valid) {}
				})
			}
		}
	}
</script>

<style scoped="scoped">

</style>
